export const messages = {
    en: {
        message: {
            nav_Features: "features",
            nav_Pricing: "Pricing",
            nav_Contactus: "Contact us",
            nav_Forlocalguide: "For Local Hosts",
            nav_ForTraveler: "For Traveler",
            nav_Benefits: "Benefits",
            nav_Login: "Log in",
            nav_Signup: "Sign up",
            nav_co: "USD",
            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            home1_Elevate: "Revolutionizing travel ",
            home1_with: "with personalized journeys",
            home1_Experience: "Join us on a journey to transform how you travel. Farrther seamlessly connects explorers with local guides, who offer not just companionship but expert concierge services.",
            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            home2_Elevate: "Elevate your business",
            home2_with: "with farrther Select",
            home2_Experience: "Experience the power of global connectivity as we link customer demand worldwide with your unique offers. Let's expand your horizons together.",

            home2_Get: "Get started",
            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            home1b_steps: "Steps",
            home1b_how: "How it works",
            home1b_unlock: "Unlock the potential of your local business in the world of travel with our easy 3-step application process.",

            home1b_Application: "Application",
            home1b_Begin: "Begin by completing a short application form, sharing what makes your business special and why it's a great match for Farrther Select.",

            home1b_Verification: "Verification",
            home1b_After: "After approval, we'll work closely together to authenticate your business information. This involves confirming your location, services, and any exclusive offers for farrther Select travelers.",

            home1b_Partner: "Partner",
            home1b_Your: "Your business will become a part of the Farrther Select network. Travelers can explore your services, include your business in their travel plans, and share their experiences with other fellow travelers.",

            home1b_Learn: "Learn more",
            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            home1c_Benefits: "Benefits",
            home1c_Elevate: "Elevate Your Local Business",
            home1c_By: "By joining Farrther Select, your local business offers unique experiences, gains exposure, and fosters lasting, meaningful connections with travelers.",

            home1c_Global: "Global Exposure",
            home1c_Gain: "Gain access to a global audience of travelers actively seeking unique and authentic experiences in your area",

            home1c_Enhanced: "Enhanced Credibility",
            home1c_Become: "Become part of a select group of businesses known for their commitment to quality, safety, and excellence.",

            home1c_Increased: "Increased Revenue",
            home1c_Tap: "Tap into the lucrative tourism market by offering tailored services and unforgettable local experiences.",

            home1c_Marketing: "Marketing and Support",
            home1c_Gainaccess: "Gain access to marketing support and tools to promote your services to a wider audience.", 

            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

            home1d_Support: "Support",
            home1d_Everything: "Everything you need to know about the Farrther Select experience. Can’t find the answer you’re looking for? Please chat to our friendly team.",
            
            home1d_Q1: "How does the booking process work for travelers who want to experience our services through your app?",
            home1d_A1: "Travelers can easily browse and book your services through our app. They select their preferred date and time, make a reservation, and receive a confirmation.",

            home1d_Q2: "What types of businesses can become partners?",
            home1d_A2: "Yes, you can try us for free for 30 days. If you want, we’ll provide you with a free, personalized 30-minute onboarding call to get you up and running as soon as possible.",

            home1d_Q3: "Do I have control over pricing and availability?",
            home1d_A3: "Yes, you can try us for free for 30 days. If you want, we’ll provide you with a free, personalized 30-minute onboarding call to get you up and running as soon as possible.",

            home1d_Q4: "Is there a cost associated with becoming a partner?",
            home1d_A4: "Yes, you can try us for free for 30 days. If you want, we’ll provide you with a free, personalized 30-minute onboarding call to get you up and running as soon as possible.",

            home1d_Q5: "How will partnering with your app affect my online presence and reputation?",
            home1d_A5: "Yes, you can try us for free for 30 days. If you want, we’ll provide you with a free, personalized 30-minute onboarding call to get you up and running as soon as possible.",

            home1d_Q6: "How do I receive payments for bookings made through the app?",
            home1d_A6: "Yes, you can try us for free for 30 days. If you want, we’ll provide you with a free, personalized 30-minute onboarding call to get you up and running as soon as possible.",

            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

            home2e_Let: "Let's become partners",
            home2e_There: "There is no cost to register. Start reaping the benefits of farrther Select!",

            home2e_Bna: "Business name*",
            home2e_Bwe: "Business website*",
            home2e_Bem: "Business number*",
            home2e_Bnu: "Business number*",
            home2e_Ain: "Additional information",

            home2e_Lum: "Leave us a message...",

            home_benifits_title: "Why Choose Our Platform?",
            home_benifits_description: "We're building a revolutionary platform that connects travelers with local guides for authentic, memorable experiences. ",

            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

            hero_title1: "Travel guided by trusted locals.",
            hero_description1:"Farrther connects travelers with local hosts for personalized support, thoughtful recommendations, and a more seamless way to experience your destination.",
            hero_description2:"",
            hero_guide_button:"Apply as a Local Host",
            hero_traveler_button:"Join the Waitlist",
            hero_description3:"Early access • Be among the first to join when we launch",

            benefits_title: "Why Farrther",
            benefits_sub_title:"Travel is better when you have a trusted local in your corner.",
            benefits_title_card1:"Your local host",
            benefits_description_card1:"A trusted local to guide and support your trip.",
            benefits_title_card2:"Concierge level assistance",
            benefits_description_card2:"Reservations, shopping, translation, and more all handled on your terms.",
            benefits_title_card3:"Transportation, your pace",
            benefits_description_card3:"Coordinated rides with drivers who wait when you need them.",
            benefits_title_card4:"Trusted local insight",
            benefits_description_card4:"Recommendations you won’t find in generic guides.",
            benefits_title_card5:"Real-time problem solving",
            benefits_description_card5:"Help when plans change, questions come up, or you’re stuck.",
            benefits_title_card6:"Everything in one app",
            benefits_description_card6:"Message, manage requests, and keep everything organized.",

            steps_title: "How it works",
            steps_sub_title:"Simple, personal support for travelers and local hosts.",
            steps_localguide_title:"For Local Hosts",
            steps_localguide_steps_title1:"Apply to Join",
            steps_localguide_steps_description1:"Share your information to begin the local host review process.",
            steps_localguide_steps_title2:"Build Your Host Profile",
            steps_localguide_steps_description2:"Build a profile that showcases your city, your interests, your local expertise, and the qualities that make you unique as a host.",
            steps_localguide_steps_title3:"Connect With Travelers",
            steps_localguide_steps_description3:"Connect with travelers looking for assistance while they enjoy your city.",
            steps_localguide_steps_title4:"Share Your Area",
            steps_localguide_steps_description4:"Earn by sharing your local knowledge, offering personalized help, and making each trip more seamless.",
            steps_traveler_title:"For Travelers",
            steps_traveler_steps_title1:"Tell Us About Your Trip",
            steps_traveler_steps_description1:"Share where you're going, what you would like to experience, and the kind of support that would make your trip easier.",
            steps_traveler_steps_title2:"Connect With a Local Host",
            steps_traveler_steps_description2:"Connect with a local host who knows the local sights, understands your interests, and can provide the support you need.",
            steps_traveler_steps_title3:"Enjoy On-the-Ground Support",
            steps_traveler_steps_description3:"Enjoy having someone by your side to assist with translation, transportation, and discovering sights off the beaten path.",
            steps_traveler_steps_title4:"Make the Most of Your Trip",
            steps_traveler_steps_description4:"Spend less time figuring things out and more time enjoying what your destination has to offer.",

            cta_title:"Ready to Start Your Journey?",
            cta_description:"Join our waitlist today and be the first to experience authentic travel connections when we launch.",
            cta_joiin_guide:"Join as a Guide",
            cta_join_traveler:"Join as a Traveler",

            faq_question1:"What is Farrther?",
            faq_title1:"Farrther connects travelers with trusted local hosts who help with the real-life details of travel, recommendations, logistics, and on-the-ground support, so your trip feels effortless.",
            faq_points1:[],
            faq_question2:"How does Farrther work for travelers?",
            faq_title2:"You’ll use the Farrther app to connect with a local host in your destination. Ask questions, get recommendations, and get help as your plans evolve, before you arrive and while you’re there.",
            faq_points2:[],
            faq_question3:"What can a Farrther local host help me with?",
            faq_title3:"Local hosts can help with restaurant and activity recommendations, shopping assistance, translation support, getting around, and real-time planning, so you spend less time figuring things out and more time enjoying your trip.",
            faq_points3:[],
            faq_question4:"How is Farrther different from a tour guide or travel agency?",
            faq_title4:"Farrther isn’t a group tour or a pre-set itinerary. It’s flexible, personal support from a local host, tailored to your preferences, schedule, and travel style.",
            faq_points4:[],
            faq_question5:"When is Farrther launching, and where first?",
            faq_title5:"We’re launching soon and rolling out by destination. Join the waitlist to be notified when Farrther becomes available in your area and to get early access updates.",
            faq_points5:[],
            faq_question6:"How do I join the waitlist?",
            faq_title6:"Click “Join the waitlist” and share a few quick details. We’ll email you as soon asFarrther is ready, plus any early access opportunities.",
            faq_points6:[],


            traveler_model_title:"Join as a Traveler",
            traveler_model_description:"Get early access and discover authentic local experiences worldwide.",
            localguide_model_title:"Join as a Guide",
            localguide_model_description:"Share your local expertise and connect with travelers.",

            full_name:"Full Name",
            email_id:"Email Id",
            phone_number:"Phone Number",
            city:"City",
            get_early_access:"Get Early Access",
            sending:"Sending...",
            model_footer_text:"By signing up, you’ll be among the first to know when we launch",

            support_title:"Let's become partners",
            support_description:"There is no cost to register. Start reaping the benefits of farrther Select!",
            business_name:"Business Name *",
            business_website:"Business Website *",
            business_number:"Business Number *",
            business_email:"Business Email *",
            addional_information:"Additional Information",
            get_started:"Get started",

            footer_menu1:"About",
            footer_menu2:"Why Choose Us",
            footer_menu3:"How it Works?",
            all_rights_reserved:"2026 Farrther Select. All rights reserved.",



            ////////////////////////////////

            //////////////////////////////////////


            foo_Get: "Get the app",

            foo_Stay: "Stay up to date",

            foo_Subscribe: "Subscribe",

            foo_Design: "Design amazing digital experiences that ",
            foo_create: "create more happy in the world.",

            foo_Overview: "Overview",
            foo_Benefits: "Benefits",
            foo_Features: "Features",
            foo_Pricing: "Pricing",
            foo_Help: "Help",
            foo_Privacy: "Privacy",

            foo_Stay: "Stay up to date",
            foo_Subscribe: "Subscribe",

            foo_All: "All rights reserved.",

            foo_Terms: "Terms",
            foo_Privacy: "Privacy",
            foo_Cookies: "Cookies"
        }
    },
    es: {
        message: {
            nav_Features: "Características",
            nav_Pricing: "Precios",
            nav_Contactus: "Contáctanos",
            nav_Forlocalguide: "Para Anfitriones Locales",
            nav_ForTraveler: "Guia Traveler",
            nav_Benefits: "Beneficios",
            nav_Login: "Acceso",
            nav_Signup: "Regístrate",
            nav_co: "MX",

            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            home1_Elevate: "Revolucionando los viajes ",
            home1_with: "con viajes personalizados",
            home1_Experience: "Únase a nosotros en un viaje para transformar su forma de viajar. Farrther conecta perfectamente a los exploradores con guías locales, que ofrecen no sólo compañía sino también servicios de conserjería expertos.",

            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            home2_Elevate: "Eleva tu negocio",
            home2_with: "Con farrther Select",
            home2_Experience: "Experimente el poder de la conectividad global mientras vinculamos la demanda de los clientes en todo el mundo con sus ofertas únicas. Ampliemos juntos sus horizontes.",

            home2_Get: "Comenzar",
            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            home1b_steps: "PASOS",
            home1b_how: "Cómo funciona",
            home1b_unlock: "DESBLOQUEA EL POTENCIAL DE TU NEGOCIO LOCAL EN EL MUNDO DE LOS VIAJES CON NUESTROS FÁCILES 3 PASOS PROCESO DE SOLICITUD.",

            home1b_Application: "Solicitud",
            home1b_Begin: "Comienza completando un breve formulario de solicitud, compartiendo qué hace especial a tu negocio y por qué es una excelente opción para Farrther Select.",

            home1b_Verification: "Verificación",
            home1b_After: "Después de la aprobación, trabajaremos estrechamente para autenticar la información de tu negocio. Esto implica confirmar tu ubicación, servicios y cualquier oferta exclusiva para los viajeros de Farrther Select.",

            home1b_Partner: "Socio",
            home1b_Your: "Tu negocio se convertirá en parte de la red de Farrther Select. Los viajeros pueden explorar tus servicios, incluir tu negocio en sus planes de viaje y compartir sus experiencias con otros compañeros viajeros.",

            home1b_Learn: "Más información",
            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            home1c_Benefits: "Beneficios",
            home1c_Elevate: "Potencia tu Negocio Local",
            home1c_By: "Al unirte a Farrther Select, tu negocio local ofrece experiencias únicas, gana exposición y fomenta conexiones duraderas y significativas con los viajeros.",

            home1c_Global: "Exposición Global",
            home1c_Gain: "Accede a una audiencia global de viajeros que buscan activamente experiencias únicas y auténticas en tu área.",

            home1c_Enhanced: "Credibilidad Reforzada",
            home1c_Become: "Forma parte de un grupo selecto de negocios reconocidos por su compromiso con la calidad, seguridad y excelencia.",

            home1c_Increased: "Aumento de Ingresos",
            home1c_Tap: "Ingresa al lucrativo mercado turístico ofreciendo servicios personalizados y experiencias locales inolvidables.",

            home1c_Marketing : "Marketing y Soporte",
            home1c_Gainaccess: "Accede a soporte de marketing y herramientas para promocionar tus servicios a una audiencia más amplia.",
            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            home1d_Support: "Soporte",
            home1d_Everything: "Todo lo que necesitas saber sobre la experiencia de Farrther Select. ¿No encuentras la respuesta que buscas? Por favor, chatea con nuestro amable equipo.",

            home1d_Q1: "¿Cómo funciona el proceso de reserva para los viajeros que desean experimentar nuestros servicios a través de tu aplicación?",
            home1d_A1: "Los viajeros pueden navegar y reservar fácilmente sus servicios a través de nuestra aplicación. Seleccionan la fecha y hora preferidas, hacen una reserva y reciben una confirmación.",

            home1d_Q2: "¿Qué tipos de negocios pueden convertirse en socios?",
            home1d_A2: "Negocios y empresas relacionadas al turismo (hotelería, restaurantes, algunos servicios de transporte, servicios de salud y entretenimiento, entre otros).",

            home1d_Q3: "¿Tengo control sobre precios y disponibilidad?",
            home1d_A3: "Al convertirte en socio, podras acceder al panel de administración de servicios y experiencias, ahí podras editar tus precios, información y disponibilidad de tus servicios. ",

            home1d_Q4: "¿Hay un costo asociado con ser un socio?",
            home1d_A4: "Sí, puedes probarnos gratis durante 30 días. Si lo desea, le brindaremos una llamada de incorporación gratuita y personalizada de 30 minutos para que pueda comenzar a funcionar lo antes posible.",

            home1d_Q5: "¿Cómo afectará asociarme con tu aplicación a mi presencia y reputación en línea?",
            home1d_A5: "Nuestros usuarios calificarán su experiencia en tu negocio, así que las mejores experiencias generan mejor calificación y posteriormente mejoraran la posición de tu negocio en nuestra aplicación.",

            home1d_Q6: "¿Cómo recibo los pagos por las reservas realizadas a través de la aplicación?",
            home1d_A6: "Al ser nuestro socio tendras acceso a nuestro portal de administración, en la seccion de facturacion podras ver el estatus de tus tickets por cobrar.",
            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            home2e_Let: "Vamos a ser socios",
            home2e_There: "No hay costo de registro. ¡Comienza a disfrutar de los beneficios de Farrther Select!",

            home2e_Bna: "Nombre del negocio*",
            home2e_Bwe: "Sitio web del negocio*",
            home2e_Bem: "Número de registro del negocio*",
            home2e_Bnu: "Número de teléfono del negocio*",
            home2e_Ain: "Información adicional",

            home2e_Lum: "Déjanos un mensaje...",

            ////////////////////////

            hero_title1: "Viaja guiado por lugareños de confianza.",
            hero_description1:"Farrther conecta a viajeros con anfitriones locales para ofrecer apoyo personalizado, recomendaciones thoughtful y una manera más fluida de experimentar tu destino.",
            hero_description2:"",
            hero_guide_button:"Aplica como Anfitrión Local",
            hero_traveler_button:"Únete a la Lista de Espera",
            hero_description3:"Acceso anticipado • Sé de los primeros en unirte cuando lancemos la plataforma.",

            benefits_title: "¿Por qué más lejos?",
            benefits_sub_title:"Viajar es mejor cuando tienes un local de confianza a tu lado.",
            benefits_title_card1:"Tu anfitriona local",
            benefits_description_card1:"Un local de confianza para guiarte y apoyarte en tu viaje.",
            benefits_title_card2:"Asistencia de nivel conserje",
            benefits_description_card2:"Reservas, compras, traducción y mucho más, todo gestionado según sus términos.",
            benefits_title_card3:"Transporte, a tu ritmo",
            benefits_description_card3:"Viajes coordinados con conductores que esperan cuando los necesitas.",
            benefits_title_card4:"Información local confiable",
            benefits_description_card4:"Recomendaciones que no encontrarás en guías genéricas.",
            benefits_title_card5:"Resolución de problemas en tiempo real",
            benefits_description_card5:"Ayuda cuando los planes cambian, surgen preguntas o estás estancado.",
            benefits_title_card6:"Todo en una sola aplicación",
            benefits_description_card6:"Envía mensajes, gestiona solicitudes y mantén todo organizado.",

            steps_title: "Cómo funciona",
            steps_sub_title:"Apoyo simple y personalizado para viajeros y anfitriones locales.",
            steps_localguide_title:"Para Anfitriones Locales",
            steps_localguide_steps_title1:"Solicita Unirte",
            steps_localguide_steps_description1:"Comparte tu información para comenzar el proceso de revisión como anfitrión local.",
            steps_localguide_steps_title2:"Crea Tu Perfil de Anfitrión",
            steps_localguide_steps_description2:"Crea un perfil que muestre tu ciudad, tus intereses, tu experiencia local y las cualidades que te hacen único como anfitrión.",
            steps_localguide_steps_title3:"Conéctate con Viajeros",
            steps_localguide_steps_description3:"onéctate con viajeros que buscan asistencia mientras disfrutan de tu ciudad.",
            steps_localguide_steps_title4:"Comparte Tu Zona",
            steps_localguide_steps_description4:"Gana dinero compartiendo tu conocimiento local, ofreciendo ayuda personalizada y haciendo que cada viaje sea más fluido.",
            steps_traveler_title:"Para las viajeros",
            steps_traveler_steps_title1:"Cuéntanos Sobre Tu Viaje",
            steps_traveler_steps_description1:"Comparte a dónde vas, qué te gustaría experimentar y el tipo de apoyo que haría tu viaje más fácil.",
            steps_traveler_steps_title2:"Conéctate con un Anfitrión Local",
            steps_traveler_steps_description2:"Conéctate con un anfitrión local que conozca los lugares de interés, entienda tus preferencias y pueda brindarte el apoyo que necesitas.",
            steps_traveler_steps_title3:"Disfruta del Apoyo en el Destino",
            steps_traveler_steps_description3:"Disfruta de tener a alguien a tu lado para ayudarte con la traducción, el transporte y el descubrimiento de lugares fuera de los circuitos turísticos habituales.",
            steps_traveler_steps_title4:"Aprovecha al Máximo Tu Viaje",
            steps_traveler_steps_description4:"Dedica menos tiempo a resolver inconvenientes y más tiempo a disfrutar de lo que tu destino tiene para ofrecer.",


            cta_title:"¿Listo para comenzar tu viaje?",
            cta_description:"Únete hoy mismo a nuestra lista de espera y sé el primero en experimentar conexiones de viaje auténticas cuando lancemos nuestro servicio.",
            cta_joiin_guide:"Únete como guía",
            cta_join_traveler:"Únete como viajero",

            faq_question1:"¿Qué es Farrther?",
            faq_title1:"Farrther conecta a los viajeros con anfitriones locales de confianza que ayudan con los detalles reales del viaje (recomendaciones, logística y apoyo en el terreno) para que su viaje se sienta sin esfuerzo.",
            faq_points1:[],
            faq_question2:"¿Cómo trabaja Farrther para las viajeros?",
            faq_title2:"Usarás la app de Farrther para conectar con un anfitrión local en tu destino. Haz preguntas, obtén recomendaciones y recibe ayuda a medida que tus planes evolucionan, tanto antes de tu llegada como durante tu estancia.",
            faq_points2:[],
            faq_question3:"¿En qué me puede ayudar un anfitrión local de Farrther?",
            faq_title3:"Los anfitriones locales pueden ayudarte con recomendaciones de restaurantes y actividades, asistencia con compras, apoyo de traducción, desplazamientos y planificación en tiempo real, para que pases menos tiempo pensando en todo y más tiempo disfrutando de tu viaje.",
            faq_points3:[],
            faq_question4:"¿En qué se diferencia Farrther de un guía turístico o una agencia de viajes?",
            faq_title4:"Farrther no es un tour grupal ni un itinerario preestablecido. Ofrece apoyo personalizado y flexible de un guía local, adaptado a tus preferencias, horario y estilo de viaje.",
            faq_points4:[],
            faq_question5:"¿Cuándo se lanzará Farrther y dónde comenzará primero?",
            faq_title5:"Próximamente lanzaremos el servicio por destino. Únete a la lista de espera para recibir notificaciones cuando Farrther esté disponible en tu zona y recibir actualizaciones anticipadas sobre el acceso.",
            faq_points5:[],
            faq_question6:"¿Cómo me uno a la lista de espera?",
            faq_title6:"Haz clic en 'Únete a la lista de espera' y comparte algunos detalles. Te enviaremos un correo electrónico en cuanto Farrther esté listo, además de cualquier oportunidad de acceso anticipado.",
            faq_points6:[],

            traveler_model_title:"Únete como viajero",
            traveler_model_description:"Obtenga acceso anticipado y descubra auténticas experiencias locales en todo el mundo.",
            localguide_model_title:"Únase como guía",
            localguide_model_description:"Comparte tu experiencia local y conéctate con viajeros.",

            full_name:"Nombre completo",
            email_id:"ID de correo electrónico",
            phone_number:"Número de teléfono",
            city:"Ciudad",
            get_early_access:"Obtenga acceso temprano",
            sending:"Envío...",
            model_footer_text:"Al registrarte, serás uno de los primeros en saber cuándo lanzamos",

            support_title:"Seamos socios",
            support_description:"Registrarse es gratuito. ¡Comienza a disfrutar de los beneficios de farrther Select!",
            business_name:"Nombre comercial *",
            business_website:"Sitio web empresarial *",
            business_number:"Número de negocio *",
            business_email:"Correo electrónico comercial *",
            addional_information:"Información adicional",
            get_started:"Empezar",

            footer_menu1:"Acerca de",
            footer_menu2:"¿Por qué elegirnos?",
            footer_menu3:"¿Cómo funciona?",
            all_rights_reserved:"© 2026 Farrther Select. Todos los derechos reservados.",


            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            foo_Get: "Obtener la aplicación",

            foo_Stay: "Mantente actualizado",

            foo_Subscribe: "Suscribirse",

            foo_Design: "Diseña experiencias digitales increíbles que ",
            foo_create: "crean más felicidad en el mundo.",

            foo_Overview: "Visión general",
            foo_Benefits: "Beneficios",
            foo_Features: "Características",
            foo_Pricing: "Precios",
            foo_Help: "Ayuda",
            foo_Privacy: "Privacidad",

            foo_Stay: "Mantente actualizado",
            foo_Subscribe: "Suscribirse",

            foo_All: "Todos los derechos reservados.",

            foo_Terms: "Términos",
            foo_Privacy: "Privacidad",
            foo_Cookies: "Cookies"

        }
    }
}